.verdocs-flag {
  position: absolute;
  left: 100%;
  width: 110px;
  height: 24px;
  padding-left: 14px;
  background-color: #13a10e;
  // background-color: red !important; // DEBUGGING
  // Use px for clip-path to keep arrow constant size regardless of width
  clip-path: polygon(0px 50%, 14px 0, 100% 0, 100% 100%, 14px 100%);
  display: flex;
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  line-height: 1;

  &:hover {
    filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.3));
    transform: translateX(-1px); // Subtle move left on hover
  }

  &.variant-next {
    clip-path: none;
    border-radius: 0;
    margin-left: 14px; // Counteract the left: calc(100% - 14px) from JS
    width: 96px; // 110px - 14px arrow width
    padding-left: 0;
  }

  .label {
    display: flex;
    align-items: center;
    justify-content: center; // Center text
    width: 100%; // Ensure it takes full width for centering
    gap: 4px;
  }

  .link {
    text-decoration: underline;
    cursor: pointer;
    font-weight: 400;

    &:hover {
      text-decoration: none;
    }
  }
}